const style = (theme) => ({
  root: {
    '& > div': {
      marginTop: 100,
      marginBottom: 100,
      [theme.mq.sm]: {
        marginBottom: 50,
      },
    },
    '& .container': {
      '&:not(:last-child)': {
        marginBottom: 0,
        [theme.mq.md]: {
          marginBottom: 0,
        },
        [theme.mq.md]: {
          marginBottom: 0,
        },
      },
    },
  },
})

export default style
